export default __webpack_public_path__ + "static/media/img-sertif-penyelesaian-new.181ee8c6.svg";